<table
 (matSortChange)="onSortChange($event)"

  [dataSource]="dataSource"
  
  mat-table
  matSort
  style="width: 100%"
>


 <ng-container matColumnDef="supplierNm">
  <th *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "Non_de_la_societe" | translate }}
  </th>
  <td *matCellDef="let d" mat-cell>{{ d.supplierNm }}</td>
</ng-container>



<ng-container matColumnDef="regReplyEmail">
  <th  *matHeaderCellDef mat-header-cell mat-sort-header>
   
    {{ "email" | translate }}
  </th>
  <td  *matCellDef="let d" mat-cell>

     {{ d.regReplyEmail }}
    </td>
</ng-container>

<ng-container matColumnDef="telNo">
  <th  *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "N_de_teléphone_fixe" | translate }}
  </th>
  <td *matCellDef="let d" mat-cell>
  
      {{ d.telNo }}
</ng-container>
<ng-container matColumnDef="faxNo">
  <th  *matHeaderCellDef mat-header-cell mat-sort-header>
    {{ "N_de_fax" | translate }}
  </th>
  <td *matCellDef="let d" mat-cell>
   
      {{ d.faxNo }}  </td>
</ng-container>








 -->
<!--  <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ column | translate }}
    </th>
    <td *matCellDef="let type" mat-cell>
      {{ type[column] | typedValue | async }}
    </td>
  </ng-container> -->

 
  <tr  *matHeaderRowDef="readColumns" mat-header-row></tr>
  <tr  *matRowDef="let row; columns: readColumns" mat-row></tr> 
  
   


 
</table>
<app-empty-list-container
[list]="dataSource.data"
[withoutBorder]="true"
></app-empty-list-container>